
import { useContext, useEffect, useMemo, useState } from "react";
import { faChevronDown } from '@fortawesome/free-solid-svg-icons'
import { faChevronUp } from '@fortawesome/free-solid-svg-icons'
import Calendar from 'react-calendar';
import clsx from "clsx";
import {  addZero, fromGetDayToWeekDay, fromGetMonthToMonthName } from "../../../../shared/utils/formatFunction";
import { DatesCard } from "./DatesCard";
import Select, { StylesConfig } from 'react-select';
import mockTime from "./../../../../jsonMock/mockTime.json"
import { customStyles } from "../../../../shared/style";
import useMediaQuery from "../../../../hook/useMediaQuery";
import { MediaMobile } from "../../../../api/const/MediaQuery";
import { OptionTypes } from "components/types/types";
import { Loader } from "components/atoms";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { isAbsolute } from "path";
import { getMatchSlots } from "api/calls";
import { AppGeneralContext } from "shared/GeneralContext/GeneralContext";



type DatesFormProps = {
    getValue: (par: string | Date) => void
}



export const DatesForm = ({ getValue }: DatesFormProps) => {
    const tomorrow = new Date( Date.now() + (3600 * 1000 * 24))
    const {setErrorModal}= useContext(AppGeneralContext)
    const mobile = useMediaQuery(MediaMobile)
    const [value, setValue] = useState(tomorrow);
    const [timeSlots, setTimeSlots] = useState<OptionTypes[]>([]);
    const [finalDate, setFinalDate] = useState<Date>()
    const [hour, setHour] = useState<number>()
    const [minutes, setMinutes] = useState<number>()
    const [slotSelected,setSlotSelected] = useState<string>("")
    const style = customStyles as StylesConfig
    const [isOpen, setIsOpen]= useState<boolean>(false)

    


    // mock dates
    useEffect(()=>{

        getMatchSlots().then((res) =>{
            if(!res.isSuccess || !res.response){
                setErrorModal(res.error)
                return 
            }
            
            const resp = res.response.data
            const timeSLots =  resp.map(x =>{
                let date = new Date(x.value)
                let dateHour = date.getUTCHours()
                let dateMinutes = date.getUTCMinutes()
                let newDate =  new Date( 0,0,0, dateHour, dateMinutes)
                return {
                    label: x.label,
                    value: newDate.toString()
                }
            })
            setTimeSlots(timeSLots)
        })
        
    
    },[])


    function SelectTime (time: string){
        setSlotSelected(time);
        const date = new Date(time);
        setHour(date.getHours());
        setMinutes(date.getMinutes())

    }
    

    useEffect(() => {
        if (hour !== undefined && minutes !== undefined) {
            let date = new Date()
            date.setFullYear(value.getFullYear())
            date.setMonth(value.getMonth())
            date.setDate(value.getDate())
            date.setHours(hour)
            date.setMinutes(minutes)
            date.setSeconds(0)
            date.setMilliseconds(0)
            setFinalDate(date)
        }

    }, [value, hour, minutes])

    useEffect(() => {
        if (finalDate !== undefined){
            getValue(finalDate)
        }      
    }, [finalDate])

    // day of tomorrow
   

    function handleOpen(){
        setIsOpen(x=>!x)
    }


    return (
        <div className={clsx("d-flex ",
            { "flex-row": !mobile },
            { " flex-column position-relative": mobile }
        )}>
            {mobile ?
              <div className={clsx("ps-2 pt-3 pe-2 pb-3  calendar-bg w-100 position-relative")}>
                <div className="form-input d-flex align-items-center flex-row justify-content-between" onClick={handleOpen}>
                    <p className="text-start fw-bold p-0 m-0">{value.toDateString()}</p>
                    <FontAwesomeIcon color='var(--primary)' icon={isOpen ?  faChevronUp : faChevronDown} />
                </div>
                {isOpen && 
                <div className="position-absolute form-input mt-1 pt-1 option-height " style={{width:"95.5%", zIndex:550}}>
                    <div className="w-100 h-100 my-2">
                     <Calendar minDate={tomorrow} 
                     onClickDay={(e:any) => {
                        if (!e) {
                            return
                        }
                        if (e instanceof Date) {
                            setIsOpen(false)
                            setValue(e)
                            return
                        }
                        if (!e[0]) {
                            return
                        }
                        setIsOpen(false)
                        setValue(e[0])
                        }}
                    className={"option-height-cal"}
                    value={value} locale={"en"} />
                    </div>
                </div>
                }
            
              </div>
            
            
            
            :<div className={clsx("ps-2 pt-3 pe-2 pb-3  calendar-bg w-60")}>
                <Calendar minDate={tomorrow} onChange={(e:any) => {
                    if (!e) {
                        return
                    }
                    if (e instanceof Date) {
                        setValue(e)
                        return
                    }
                    if (!e[0]) {
                        return
                    }
                    setValue(e[0])
                    }} value={value} locale={"en"} />
            </div>}
            <div className={clsx(" mt-2   time-section ",
                { "w-40 ps-3" : !mobile },
                { "w-100 ": mobile })}>
                <p className="p-0 m-0 pt-3 ps-2 pb-2 ">Select time:</p>
                <div className={clsx("d-flex flex-row flex-wrap",
                 { "w-100   justify-content-start " : !mobile },
                 { "w-100 ps-1 pe-1  justify-content-between ": mobile })}>
                { timeSlots.length !== 0 ? timeSlots.map((slot) => {
                    return (
                        <div key={slot.label} className={clsx("slot m-1  p-1" ,
                        { "slot" : slot.value !== slotSelected },
                        {"slot-active" : slot.value === slotSelected })} onClick={()=>SelectTime(slot.value)}>
                            {slot.label}
                        </div>
                    )
                }):
                 <Loader/>
                }
                </div>
               
            </div>
        </div>
    )
}